import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  Col,
  Input,
  Row,
  message,
  Modal,
  DatePicker,
  Spin,
  Upload,
  Button
} from "antd";
import FormConfig from "../../Config/FormConfig.js";
import APIService from "../../Service/APIService";
import { Formik } from "formik";
import * as yup from 'yup';
import { CheckOutlined, PlusOutlined, InboxOutlined, LoadingOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import Select from 'react-select';
import axios from 'axios';
import AddContactForm from './AddContactForm';
import { useAuth } from "../AuthProvider.js";
import CustomHeader from "../CustomHeader/CustomHeader";
import moment from "moment";

const IVRFormAdd = () => {
  const { user } = useAuth();
  const userData = user;
  const params = useParams();
  const [fieldsArr, setFieldsArr] = React.useState([]);
  const [initialValues, setInitialValues] = React.useState(null);
  const [validationSchema, setValidationSchema] = React.useState(null);
  const [ivrData, setIvrData] = React.useState(null);
  const [accountOptions, setAccountOptions] = React.useState([]);
  const [ivrOptions, setIvrOptions] = React.useState(null);
  const [showLoader, setShowLoader] = React.useState(false);
  const [isEditable, setIsEditable] = useState(false);

  const [patientDemoFileList, setPatientDemoFileList] = React.useState([]);
  const [insuranceCardFileList, setInsuranceCardFileList] = React.useState([]);
  const [secondaryInsuranceCardFileList, setSecondaryInsuranceCardFileList] =
    React.useState([]);
  const [patientClinicalRecordFileList, setPatientClinicalRecordFileList] =
    React.useState([]);

  const generateFieldsArray = (data) => {
    const doFields = FormConfig.IVRFormAdd;
    const val = generateInitialValues(doFields, data);
    val["SubmissionDate"] =
      val["SubmissionDate"] === null ? moment() : moment(val["SubmissionDate"]);
    val["PatientDOB"] =
      val["PatientDOB"] === null ? null : moment(val["PatientDOB"]);
    val["SubscriberDOB"] =
      val["SubscriberDOB"] === null ? null : moment(val["SubscriberDOB"]);
    val["SecondarySubscriberDOB"] =
      val["SecondarySubscriberDOB"] === null
        ? null
        : moment(val["SecondarySubscriberDOB"]);
    val["DateOfProcedure"] =
      val["DateOfProcedure"] === null ? null : moment(val["DateOfProcedure"]);
    val["SubmittedBy"] = userData?.FirstName + " " + userData?.LastName;
    val["SubmittedByUserID"] = userData?.UserID;
    // if (val["PatientDemoSheet"] !== null) {
    //   const arrayBuffer = val["PatientDemoSheet"]?.data;
    //   const bytes = new Uint8Array(arrayBuffer);
    //   const blob = new Blob([bytes], { type: "application/pdf" });
    //   setPatientDemoSheets(blob);
    //   setPatientDemoSheetsFilename(val["PatientDemoSheetsFilename"]);
    //   setPatientDemoFileList([{ name: val["PatientDemoSheetsFilename"], status: 'done', uid: '1' }]);
    // }
    // if (val["PrimaryInsuranceCard"] !== null) {
    //   const arrayBuffer = val["PrimaryInsuranceCard"]?.data;
    //   const bytes = new Uint8Array(arrayBuffer);
    //   const blob = new Blob([bytes], { type: "application/pdf" });
    //   setPatientInsuranceCard(blob);
    //   setPatientInsuranceCardFilename(val["PatientInsuranceCardFilename"]);
    //   setInsuranceCardFileList([{ name: val["PatientInsuranceCardFilename"], status: 'done', uid: '1' }]);
    // }
    // if (val["SecondaryInsuranceCard"] !== null) {
    //   const arrayBuffer = val["SecondaryInsuranceCard"]?.data;
    //   const bytes = new Uint8Array(arrayBuffer);
    //   const blob = new Blob([bytes], { type: "application/pdf" });
    //   setSecondaryInsuranceCard(blob);
    //   setSecondaryInsuranceCardFilename(val["SecondaryInsuranceCardFilename"]);
    //   setSecondaryInsuranceCardFileList([{ name: val["SecondaryInsuranceCardFilename"], status: 'done', uid: '1' }]);
    // }
    // if (val["PatientClinicalRecord"] !== null) {
    //   const arrayBuffer = val["PatientClinicalRecord"]?.data;
    //   const bytes = new Uint8Array(arrayBuffer);
    //   const blob = new Blob([bytes], { type: "application/pdf" });
    //   setPatientClinicalRecord(blob);
    //   setPatientClinicalRecordFilename(val["PatientClinicalRecordFilename"]);
    //   setPatientClinicalRecordFileList([{ name: val["PatientClinicalRecordFilename"], status: 'done', uid: '1' }]);
    // }
    setInitialValues(val);
    setFieldsArr(doFields);
    return doFields;
  };

  const getIvrById = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getivrbyid?ID=${params.id}`
    );
    console.log("IVR Data: ", response?.data?.data);
    setIvrData(response?.data?.data);
    return response?.data?.data;
  };

  const generateValidationSchema = (formFieldArr) => {
    let obj = {}; // schema object
    for (const cur of formFieldArr) {
      obj[cur.backendName] = cur.validationFunction;
    }
    return obj;
  };

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    console.log("Data: ", data);
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] =
          cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    console.log("Initial Values:", obj);
    return obj;
  };

  const getIVROptions = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      "account/ivrverification"
    );
    console.log("IVR Options: ", response);
    // return;
    const respObj = response?.data?.data;
    setIvrOptions(respObj);
    let tempAccOptions = [];
    respObj?.forEach((ele) => {
      tempAccOptions.push({
        value: ele.ID,
        label: ele.AccountName,
        accountData: ele,
      });
    });
    setAccountOptions(tempAccOptions);
  };

  const [placeOfServiceOptions, setPlaceOfServiceOptions] =
    React.useState(null);

  const getPlaceOfServiceOptions = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("getplaceofservice");
    console.log("Place Of Service Options: ", response);
    const respObj = response?.data?.data;
    let tempPlaceOfServiceOptions = [];
    respObj?.forEach((ele) => {
      tempPlaceOfServiceOptions.push({
        value: ele.PlaceOfService,
        label: ele.PlaceOfService,
      });
    });
    setPlaceOfServiceOptions(tempPlaceOfServiceOptions);
  };

  const [shipToContactOptions, setShipToContactOptions] = React.useState(null);
  const [shipToAccountData, setShipToAccountData] = React.useState(null);

  const [selectedAccount, setSelectedAccount] = React.useState(null);

  const [accBaaStatus, setAccBaaStatus] = React.useState(null);
  const [showBAAModal, setShowBAAModal] = React.useState(false);

  const handleAccountSelect = async (value) => {
    const serv = new APIService();
    const selAcc = accountOptions.find((ele) => ele.value === value);
    console.log("Selected Account: ", selAcc);
    if (selAcc?.accountData?.BAA === false) {
      // fetch parent account
      if (selAcc.accountData?.IsChildAccount) {
        const parentResp = await serv.getDataFromBackend(
          `getaccountbyid?ID=${selAcc.accountData?.ParentAccountID}`
        );
        console.log("Parent Account Data: ", parentResp?.data?.data);
        if (parentResp?.data?.data?.BAA === false) {
          setShowBAAModal(true);
          setAccBaaStatus(parentResp?.data?.data?.BAA);
        }
      } else {
        setShowBAAModal(true);
        setAccBaaStatus(selAcc?.accountData?.BAA);
      }
    }

    setSelectedAccount(selAcc?.accountData);
    // const response = await serv.getDataFromBackend(`getaccountbyid?ID=${value}`);
    // console.log("Account Data: ", response?.data?.data);
    setShipToAccountData(selAcc?.accountData);

    // get contact by account
    const contactResponse = await serv.getDataFromBackend(
      `getcontactsbyaccount?AccountID=${value}`
    );
    console.log("Contact Data: ", contactResponse?.data?.data);
    let contacts = contactResponse?.data?.data;
    contacts.map((ele) => {
      ele["value"] = ele.ID;
      ele["label"] = ele.FirstName + " " + ele.LastName;
      return ele;
    });
    setShipToContactOptions(contacts);
    return selAcc?.accountData;
  };

  const handleButtonClick = (submitForm) => {
    if (isEditable) {
      submitForm(); // Trigger form submission
    } else {
      setIsEditable(true); // Enable edit mode
    }
  };

  const [patientDemoSheets, setPatientDemoSheets] = React.useState(null);
  const [patientDemoSheetsFilename, setPatientDemoSheetsFilename] =
    React.useState(null);
  const [patientInsuranceCard, setPatientInsuranceCard] = React.useState(null);
  const [patientInsuranceCardFilename, setPatientInsuranceCardFilename] =
    React.useState(null);
  const [secondaryInsuranceCard, setSecondaryInsuranceCard] =
    React.useState(null);
  const [secondaryInsuranceCardFilename, setSecondaryInsuranceCardFilename] =
    React.useState(null);
  const [patientClinicalRecord, setPatientClinicalRecord] =
    React.useState(null);
  const [patientClinicalRecordFilename, setPatientClinicalRecordFilename] =
    React.useState(null);

  const handleFile = async ({ file, onSuccess }, type) => {
    // setIvrReport(file);
    if (type === "PatientDemoSheets") {
      if (file.size > 4194304) {
        message.error(
          `${file.name} is too large, please select a file less than 4MB`
        );
        return;
      }
      setPatientDemoSheets(file);
      setPatientDemoSheetsFilename(file.name);
      setPatientDemoFileList([{ name: file.name, status: "done", uid: "1" }]);
    } else if (type === "PatientInsuranceCard") {
      if (file.size > 4194304) {
        message.error(
          `${file.name} is too large, please select a file less than 4MB`
        );
        return;
      }
      setPatientInsuranceCard(file);
      setPatientInsuranceCardFilename(file.name);
      setInsuranceCardFileList([{ name: file.name, status: "done", uid: "1" }]);
    } else if (type === "SecondaryInsuranceCard") {
      if (file.size > 4194304) {
        message.error(
          `${file.name} is too large, please select a file less than 4MB`
        );
        return;
      }
      setSecondaryInsuranceCard(file);
      setSecondaryInsuranceCardFilename(file.name);
      setSecondaryInsuranceCardFileList([
        { name: file.name, status: "done", uid: "1" },
      ]);
    } else if (type === "PatientClinicalRecord") {
      if (file.size > 4194304) {
        message.error(
          `${file.name} is too large, please select a file less than 4MB`
        );
        return;
      }
      setPatientClinicalRecord(file);
      setPatientClinicalRecordFilename(file.name);
      setPatientClinicalRecordFileList([
        { name: file.name, status: "done", uid: "1" },
      ]);
    }
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const downloadFile = (type) => {
    const link = document.createElement("a");
    let url = null;
    if (type === "PatientDemoSheets") {
      console.log("Patient Demo Sheets: ", patientDemoSheets);
      url = window.URL.createObjectURL(patientDemoSheets);
      link.href = url;
      link.setAttribute("download", patientDemoSheetsFilename); // Set the file name
    } else if (type === "PatientInsuranceCard") {
      url = window.URL.createObjectURL(patientInsuranceCard);
      link.href = url;
      link.setAttribute("download", patientInsuranceCardFilename); // Set the file name
    } else if (type === "SecondaryInsuranceCard") {
      url = window.URL.createObjectURL(secondaryInsuranceCard);
      link.href = url;
      link.setAttribute("download", secondaryInsuranceCardFilename); // Set the file name
    } else if (type === "PatientClinicalRecord") {
      url = window.URL.createObjectURL(patientClinicalRecord);
      link.href = url;
      link.setAttribute("download", patientClinicalRecordFilename); // Set the file name
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: [".pdf"],
    // customRequest:  handleFile,
    disabled: !isEditable,
    onChange(info) {
      const { status } = info.file;
      // set limit of 4mb on file size and throw error
      // if (info.file.size > 4194304) {
      //   message.error(`${info.file.name} is too large, please select a file less than 4MB`);
      //   return;
      // }
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  const navigate = useNavigate();
  React.useEffect(() => {
    console.log("IVR Form Add Component");
    if (userData?.Type === "Account" && !userData?.EnableIVR) {
      navigate("/");
    }
    if (userData?.Type === "Manufacturer") {
      navigate("/");
    }
    let val = null;
    if (params?.id == null || params?.id == undefined) {
      console.log("No ID");
      setIsEditable(true);
      val = generateFieldsArray(null);
      setValidationSchema(yup.object().shape(generateValidationSchema(val)));
    } else {
      getIvrById().then((data) => {
        val = generateFieldsArray(data);
        setValidationSchema(yup.object().shape(generateValidationSchema(val)));
      });
    }
    getIVROptions();
    getPlaceOfServiceOptions();
  }, []);

  const submitHandler = async (values) => {
    if (accBaaStatus === false) {
      setShowBAAModal(true);
    } else {
      Swal.fire({
        title: "Are you sure?",
        // text: "You want to submit this IVR?",
        html: `<p>
          Please allow 24 to 48 hours for the processing of benefit verifications. Results will be uploaded to the account as soon as they become available.
        </p>
        <p><strong>Note:</strong></p>
        <ul>
          <li>IVRs submitted after <strong>4:30 PM EST</strong> will be processed on the <strong>next business day</strong>.</li>
          <li>If a <strong>prior authorization is required</strong> or if we are processing an <strong>Advantage Plan</strong>, additional time may be needed—please allow a few extra days for completion.</li>
        </ul>
        <p>We appreciate your patience and understanding.</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#27a907",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const postObj = {
            ...values,
            PatientDemoSheetsFilename: patientDemoSheetsFilename,
            PatientInsuranceCardFilename: patientInsuranceCardFilename,
            SecondaryInsuranceCardFilename: secondaryInsuranceCardFilename,
            PatientClinicalRecordFilename: patientClinicalRecordFilename,
          };

          const formData = new FormData();
          formData.append("files", patientDemoSheets);
          formData.append("files", patientInsuranceCard);
          formData.append("files", secondaryInsuranceCard);
          formData.append("files", patientClinicalRecord);
          formData.append("data", JSON.stringify(values));

          console.log("Submit Handler: ", values);
          const apiServe = new APIService();
          // const response = await apiServe.addDataToBackend(values, 'account/ivrverification');

          const response = await apiServe.addFileDataToBackend(
            formData,
            "account/ivrverification",
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          console.log("Submit Handler Response: ", response);
          if (response?.status === 200 || response?.status === 201) {
            Swal.fire(
              "Submitted!",
              "IVR has been submitted successfully.",
              "success"
            );
            window.location.href = "/IVRSubmissions";
            // window.location.reload();
          } else {
            Swal.fire(
              "Error!",
              "There was an error submitting the IVR. Please try again later.",
              "error"
            );
          }
        }
      });
    }
  };

  const [showAddContactModal, setShowAddContactModal] = React.useState(false);

  const handleOkAddContact = () => {
    setShowAddContactModal(false);
  };

  const handleCancelAddContact = () => {
    setShowAddContactModal(false);
  };

  // const downloadBAAForm = async () => {
  //   setShowLoader(true);
  //   const apiServe = new APIService();
  //   const sasUrl = await apiServe.getSasToken("Resources/AdvancedSolutionBAA.pdf");

  //   const exists = await apiServe.checkBlobExists(sasUrl);
  //   if (!exists) {
  //     message.error("File does not exist.");
  //     return;
  //   }

  //   // download the file from Azure Blob Storage
  //   const link = document.createElement('a');
  //   link.href = sasUrl;
  //   link.download = '';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   setShowLoader(false);
  // }

  const downloadBAAForm = async () => {
    setShowLoader(true);
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(
      "Resources/AdvancedSolutionBAA.pdf"
    );

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      setShowLoader(false);
      return;
    }

    try {
      const response = await axios.get(sasUrl, {
        responseType: "blob",
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "AdvancedSolutionBAA.pdf"); // specify file name and extension
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url); // clean up
    } catch (error) {
      message.error("Error downloading file.");
      console.error(error);
    } finally {
      setShowLoader(false);
    }
  };

  return (
    <>
      {showLoader && (
        <Spin
          fullscreen
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
        />
      )}
      {initialValues && (
        <CustomHeader
          leftTopText="Welcome back!"
          leftBottomText={"New IVR"}
          rightTopText="Logged in as Admin"
          rightBottomText="User"
        />
      )}
      <div>
        {initialValues && (
          <Formik
            onSubmit={submitHandler}
            initialValues={initialValues}
            validationSchema={validationSchema}
          >
            {(formik) => (
              <form onSubmit={formik.handleSubmit}>
                {/* {params?.id !== null && params?.id !== undefined &&
                  <div>
                    {userData.Type === "Admin" &&
                      <div style={{ display: 'flex', gap: '16px', margin: '30px 0px 30px 0px' }}>
                        <Button
                          type="primary"
                          style={{ marginBottom: 16, background: isEditable ? '#27a907' : '#ff9202' }}
                          onClick={() => handleButtonClick(formik.handleSubmit)}
                        >
                          {isEditable ? 'Save Changes' : 'Edit'}
                        </Button>
                      </div>
                    }
                  </div>
                } */}
                <div
                  style={{
                    background: "#e3e3e3",
                    borderRadius: "5px",
                    padding: "0px 8px",
                    marginBottom: "20px",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "36px",
                    }}
                  >
                    Submission Details
                  </p>
                </div>
                <Row gutter={16}>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">
                      Account Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      onBlur={() => formik.setFieldTouched("AccountID")}
                      value={{
                        label: formik.values["AccountName"],
                        value: formik.values["AccountID"],
                      }}
                      // onChange={async (value, option) => {
                      onChange={async (selectedOption) => {
                        formik.setFieldValue(
                          "AccountName",
                          selectedOption.label
                        );
                        formik.setFieldValue("AccountID", selectedOption.value);
                        const accObj = await handleAccountSelect(
                          selectedOption.value
                        );
                        console.log("Account Object Select: ", accObj);
                        formik.setFieldValue(
                          "DistributorID",
                          accObj?.DistributorID
                        );
                        formik.setFieldValue(
                          "DistributorName",
                          accObj?.DistributorName
                        );
                        formik.setFieldValue(
                          "DistributorUserID",
                          accObj?.DistributorUserID
                        );
                        formik.setFieldValue(
                          "DistributorUsername",
                          accObj?.DistributorUsername
                        );
                        formik.setFieldValue(
                          "AccountAddressLine1",
                          accObj?.AddressLine1
                        );
                        formik.setFieldValue(
                          "AccountAddressLine2",
                          accObj?.AddressLine2
                        );
                        formik.setFieldValue("AccountCity", accObj?.City);
                        formik.setFieldValue("AccountState", accObj?.State);
                        formik.setFieldValue("AccountZip", accObj?.Zip);
                        formik.setFieldValue("AccountPhone", accObj?.Phone);
                        formik.setFieldValue("AccountFax", accObj?.Fax);
                        formik.setFieldValue(
                          "MedicareAdminContractor",
                          accObj?.MedicareAdminContractor
                        );
                        formik.setFieldValue("NPI", accObj?.NPI);
                        formik.setFieldValue("TIN", accObj?.TIN);
                        formik.setFieldValue("PTAN", accObj?.PTAN);
                      }}
                      style={{ width: "100%" }}
                      defaultValue=""
                      options={accountOptions}
                    />
                    <p className="input-subtitle">
                      Choose the account you would like to ship the product to
                      once approved
                    </p>
                    {formik.errors["AccountID"] &&
                      formik.touched["AccountID"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["AccountID"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">Distributor</label>
                    <Input
                      name="DistributorID"
                      value={formik.values.DistributorName}
                      // onChange={(event) => formik.setFieldValue('DistributorID', event.target.value)}
                      defaultValue={formik.values.DistributorName}
                      disabled
                    />
                  </Col>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">Distributor User</label>
                    <Input
                      name="DistributorUserID"
                      value={formik.values.DistributorUsername}
                      // onChange={(event) => formik.setFieldValue('DistributorID', event.target.value)}
                      defaultValue={formik.values.DistributorUsername}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Submitted By</label>
                    <Input
                      name="SubmittedBy"
                      value={formik.values.SubmittedBy}
                      // onChange={(event) => formik.setFieldValue('OrderPlacedBy', event.target.value)}
                      disabled
                    />
                    <p className="input-subtitle">This cannot be edited</p>
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Submission Date</label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("SubmissionDate")}
                      // onChange={(date, dateString) => {
                      //   formik.setFieldValue("Submission Date", date);
                      // }}
                      title={formik.values["SubmissionDate"]}
                      value={formik.values["SubmissionDate"]}
                      disabled={
                        params?.id === null || params?.id === undefined
                          ? true
                          : !isEditable
                      }
                      style={{ width: "100%" }}
                    />
                    <p className="input-subtitle">This cannot be edited</p>
                  </Col>
                </Row>
                <div
                  style={{
                    background: "#e3e3e3",
                    borderRadius: "5px",
                    padding: "0px 8px",
                    marginBottom: "20px",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "36px",
                    }}
                  >
                    Account Details
                  </p>
                </div>
                <Row gutter={16}>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">
                      Place Of Service <span style={{ color: "red" }}>*</span>
                    </label>
                    {/* <Input
                      name="PlaceOfService"
                      value={formik.values.PlaceOfService}
                      onChange={(event) => formik.setFieldValue('PlaceOfService', event.target.value)}
                      disabled={!isEditable}
                    /> */}
                    <Select
                      onBlur={() => formik.setFieldTouched("PlaceOfService")}
                      title={formik.values["PlaceOfService"]}
                      value={{
                        label: formik.values["PlaceOfService"],
                        value: formik.values["PlaceOfService"],
                      }}
                      style={{ width: "100%" }}
                      disabled={!isEditable}
                      options={placeOfServiceOptions}
                      onChange={(selectedOption) => {
                        formik.setFieldValue(
                          "PlaceOfService",
                          selectedOption.value
                        );
                      }}
                    />
                    {formik.errors["PlaceOfService"] &&
                      formik.touched["PlaceOfService"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PlaceOfService"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">Contact Name</label>
                    <Row>
                      <Col span={20} align="left">
                        <Select
                          onBlur={() =>
                            formik.setFieldTouched("AccountContactName")
                          }
                          value={{
                            label: formik.values["AccountContactName"],
                            value: formik.values["AccountContactID"],
                          }}
                          onChange={async (selectedOption) => {
                            formik.setFieldValue(
                              "AccountContactID",
                              selectedOption.value
                            );
                            formik.setFieldValue(
                              "AccountContactName",
                              selectedOption.label
                            );
                          }}
                          options={shipToContactOptions}
                          isDisabled={shipToContactOptions ? false : true}
                        />
                      </Col>
                      <Col span={4} align="center">
                        <PlusOutlined
                          style={{
                            fontSize: "36px",
                            color: "black",
                            backgroundColor: "white",
                            cursor: "pointer",
                            borderColor: "white",
                          }}
                          disabled={
                            isEditable
                              ? shipToAccountData
                                ? false
                                : true
                              : true
                          }
                          onClick={() => {
                            // console.log("Add Contact");
                            setShowAddContactModal(true);
                          }}
                        />
                      </Col>
                    </Row>
                    {/* <Input
                      name="ContactName"
                      value={formik.values.ContactName}
                      onChange={(event) => formik.setFieldValue('ContactName', event.target.value)}
                      disabled={!isEditable}
                    /> */}
                  </Col>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">
                      Physician's Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Input
                      name="PhysicianName"
                      value={formik.values.PhysicianName}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "PhysicianName",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["PhysicianName"] &&
                      formik.touched["PhysicianName"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PhysicianName"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6}>
                    <label className="form-label">Address Line 1</label>
                    <Input
                      name="AccountAddressLine1"
                      value={formik.values.AccountAddressLine1}
                      // onChange={(event) => formik.setFieldValue('ShipAddressLine1', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Address Line 2</label>
                    <Input
                      name="AccountAddressLine2"
                      value={formik.values.AccountAddressLine2}
                      // onChange={(event) => formik.setFieldValue('ShipAddressLine2', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">City</label>
                    <Input
                      name="AccountCity"
                      value={formik.values.AccountCity}
                      // onChange={(event) => formik.setFieldValue('ShipCity', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={3}>
                    <label className="form-label">State</label>
                    <Input
                      name="AccountState"
                      value={formik.values.AccountState}
                      // onChange={(event) => formik.setFieldValue('ShipState', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={3}>
                    <label className="form-label">ZIP</label>
                    <Input
                      name="AccountZip"
                      value={formik.values.AccountZip}
                      // onChange={(event) => formik.setFieldValue('ShipZip', event.target.value)}
                      disabled
                    />
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6}>
                    <label className="form-label">Phone</label>
                    <Input
                      name="ShipPhone"
                      value={formik.values.AccountPhone}
                      // onChange={(event) => formik.setFieldValue('ShipPhone', event.target.value)}
                      disabled
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Fax</label>
                    <Input
                      name="ShipFax"
                      value={formik.values.AccountFax}
                      // onChange={(event) => formik.setFieldValue('ShipFax', event.target.value)}
                      disabled
                    />
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6}>
                    <label className="form-label">
                      Medicare Admin Contractor
                    </label>
                    <Input
                      name="MedicareAdminContractor"
                      value={formik.values.MedicareAdminContractor}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "MedicareAdminContractor",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["MedicareAdminContractor"] &&
                      formik.touched["MedicareAdminContractor"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["MedicareAdminContractor"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">NPI</label>
                    <Input
                      name="NPI"
                      value={formik.values.NPI}
                      onChange={(event) =>
                        formik.setFieldValue("NPI", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">
                      TIN <span style={{ color: "red" }}>*</span>
                    </label>
                    <Input
                      name="TIN"
                      value={formik.values.TIN}
                      onChange={(event) =>
                        formik.setFieldValue("TIN", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["TIN"] && formik.touched["TIN"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["TIN"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">
                      PTAN <span style={{ color: "red" }}>*</span>
                    </label>
                    <Input
                      name="PTAN"
                      value={formik.values.PTAN}
                      onChange={(event) =>
                        formik.setFieldValue("PTAN", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["PTAN"] && formik.touched["PTAN"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PTAN"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <div
                  style={{
                    background: "#e3e3e3",
                    borderRadius: "5px",
                    padding: "0px 8px",
                    margin: "30px 0px 20px 0px",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "36px",
                    }}
                  >
                    Patient Details
                  </p>
                </div>
                <Row gutter={16}>
                  <Col span={6}>
                    <label className="form-label">
                      Patient's First Name{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Input
                      name="PatientFirstName"
                      value={formik.values.PatientFirstName}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "PatientFirstName",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["PatientFirstName"] &&
                      formik.touched["PatientFirstName"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PatientFirstName"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">
                      Patient's Last Name{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Input
                      name="PatientLastName"
                      value={formik.values.PatientLastName}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "PatientLastName",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["PatientLastName"] &&
                      formik.touched["PatientLastName"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PatientLastName"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">
                      Patient DOB <span style={{ color: "red" }}>*</span>
                    </label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("PatientDOB")}
                      title={formik.values["PatientDOB"]}
                      // placeholder={ele.placeholder}
                      value={formik.values.PatientDOB}
                      onChange={(date, dateString) =>
                        formik.setFieldValue("PatientDOB", date)
                      }
                      disabled={!isEditable}
                      style={{ width: "100%" }}
                    />
                    {formik.errors["PatientDOB"] &&
                      formik.touched["PatientDOB"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PatientDOB"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6}>
                    <label className="form-label">Patient Phone</label>
                    <Input
                      name="PatientPhone"
                      value={formik.values.PatientPhone}
                      onChange={(event) =>
                        formik.setFieldValue("PatientPhone", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["PatientPhone"] &&
                      formik.touched["PatientPhone"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PatientPhone"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Patient Email</label>
                    <Input
                      name="PatientEmail"
                      value={formik.values.PatientEmail}
                      onChange={(event) =>
                        formik.setFieldValue("PatientEmail", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["PatientEmail"] &&
                      formik.touched["PatientEmail"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PatientEmail"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6}>
                    <label className="form-label">Address Line 1</label>
                    <Input
                      name="PatientAddressLine1"
                      value={formik.values.PatientAddressLine1}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "PatientAddressLine1",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Address Line 2</label>
                    <Input
                      name="PatientAddressLine2"
                      value={formik.values.PatientAddressLine2}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "PatientAddressLine2",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">City</label>
                    <Input
                      name="PatientCity"
                      value={formik.values.PatientCity}
                      onChange={(event) =>
                        formik.setFieldValue("PatientCity", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col span={3}>
                    <label className="form-label">State</label>
                    <Input
                      name="PatientState"
                      value={formik.values.PatientState}
                      onChange={(event) =>
                        formik.setFieldValue("PatientState", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col span={3}>
                    <label className="form-label">ZIP</label>
                    <Input
                      name="PatientZip"
                      value={formik.values.PatientZip}
                      onChange={(event) =>
                        formik.setFieldValue("PatientZip", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">
                      Okay to Contact Patient
                    </label>
                    <Select
                      onBlur={() =>
                        formik.setFieldTouched("OkayToContactPatient")
                      }
                      title={formik.values["OkayToContactPatient"]}
                      value={{
                        label: formik.values["OkayToContactPatient"],
                        value: formik.values["OkayToContactPatient"],
                      }}
                      style={{ width: "100%" }}
                      disabled={!isEditable}
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      // onChange={(value, option) => {
                      onChange={(selectedOption) => {
                        formik.setFieldValue(
                          "OkayToContactPatient",
                          selectedOption.value
                        );
                      }}
                    />
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={24} style={{ width: "100%" }}>
                    <label className="form-label">Patient Demo Sheets</label>
                    <Upload.Dragger
                      {...uploadProps}
                      customRequest={({ file, onSuccess }) =>
                        handleFile({ file, onSuccess }, "PatientDemoSheets")
                      }
                      onPreview={() => downloadFile("PatientDemoSheets")}
                      fileList={patientDemoFileList}
                      onRemove={() => {
                        setPatientDemoSheets(null);
                        setPatientDemoFileList([]);
                        setPatientDemoSheetsFilename(null);
                      }}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Drag or click to upload file
                      </p>
                      <p className="ant-upload-hint">
                        Accepted format: PDF (Max file size limit: 4MB)
                      </p>
                    </Upload.Dragger>
                  </Col>
                </Row>
                <div
                  style={{
                    background: "#e3e3e3",
                    borderRadius: "5px",
                    padding: "0px 8px",
                    margin: "80px 0px 20px 0px",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "36px",
                    }}
                  >
                    Primary Insurance Details
                  </p>
                </div>
                <Row gutter={16}>
                  <Col span={6}>
                    <label className="form-label">Primary Insurance</label>
                    <Input
                      name="PrimaryInsuranceName"
                      value={formik.values.PrimaryInsuranceName}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "PrimaryInsuranceName",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["PrimaryInsuranceName"] &&
                      formik.touched["PrimaryInsuranceName"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PrimaryInsuranceName"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">
                      Policy Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <Input
                      name="PolicyNumber"
                      value={formik.values.PolicyNumber}
                      onChange={(event) =>
                        formik.setFieldValue("PolicyNumber", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["PolicyNumber"] &&
                      formik.touched["PolicyNumber"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PolicyNumber"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Subscriber Number</label>
                    <Input
                      name="SubscriberNumber"
                      value={formik.values.SubscriberNumber}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "SubscriberNumber",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["SubscriberNumber"] &&
                      formik.touched["SubscriberNumber"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["SubscriberNumber"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Subscriber DOB</label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("SubscriberDOB")}
                      title={formik.values["SubscriberDOB"]}
                      // placeholder={ele.placeholder}
                      value={formik.values.SubscriberDOB}
                      onChange={(date, dateString) =>
                        formik.setFieldValue("SubscriberDOB", date)
                      }
                      // disabled={editMode ? !ele.isEditable : ele.isEditable}
                      disabled={!isEditable}
                    />
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6}>
                    <label className="form-label">Type of Plan</label>
                    <Input
                      name="TypeOfPlan"
                      value={formik.values.TypeOfPlan}
                      onChange={(event) =>
                        formik.setFieldValue("TypeOfPlan", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["TypeOfPlan"] &&
                      formik.touched["TypeOfPlan"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["TypeOfPlan"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Insurance Phone Number</label>
                    <Input
                      name="InsurancePhoneNumber"
                      value={formik.values.InsurancePhoneNumber}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "InsurancePhoneNumber",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["InsurancePhoneNumber"] &&
                      formik.touched["InsurancePhoneNumber"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["InsurancePhoneNumber"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Provider in Network</label>
                    <Input
                      name="ProviderInNetwork"
                      value={formik.values.ProviderInNetwork}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "ProviderInNetwork",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["ProviderInNetwork"] &&
                      formik.touched["ProviderInNetwork"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["ProviderInNetwork"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={24} style={{ width: "100%" }}>
                    <label className="form-label">Patient Insurance Card</label>
                    <Upload.Dragger
                      {...uploadProps}
                      customRequest={({ file, onSuccess }) =>
                        handleFile({ file, onSuccess }, "PatientInsuranceCard")
                      }
                      onPreview={() => downloadFile("PatientInsuranceCard")}
                      fileList={insuranceCardFileList}
                      onRemove={() => {
                        setPatientInsuranceCard(null);
                        setInsuranceCardFileList([]);
                        setPatientInsuranceCardFilename(null);
                      }}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Drag or click to upload file
                      </p>
                      <p className="ant-upload-hint">
                        Accepted format: PDF (Max file size limit: 4MB)
                      </p>
                    </Upload.Dragger>
                  </Col>
                </Row>
                <div
                  style={{
                    background: "#e3e3e3",
                    borderRadius: "5px",
                    padding: "0px 8px",
                    margin: "80px 0px 20px 0px",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "36px",
                    }}
                  >
                    Secondary Insurance Details
                  </p>
                </div>
                <Row gutter={16}>
                  <Col span={6}>
                    <label className="form-label">Secondary Insurance</label>
                    <Input
                      name="SecondaryInsuranceName"
                      value={formik.values.SecondaryInsuranceName}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "SecondaryInsuranceName",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Policy Number</label>
                    <Input
                      name="SecondaryPolicyNumber"
                      value={formik.values.SecondaryPolicyNumber}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "SecondaryPolicyNumber",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["SecondaryPolicyNumber"] &&
                      formik.touched["SecondaryPolicyNumber"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["SecondaryPolicyNumber"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Subscriber Number</label>
                    <Input
                      name="SecondarySubscriberName"
                      value={formik.values.SecondarySubscriberName}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "SecondarySubscriberName",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["SecondarySubscriberName"] &&
                      formik.touched["SecondarySubscriberName"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["SecondarySubscriberName"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Subscriber DOB</label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() =>
                        formik.setFieldTouched("SecondarySubscriberDOB")
                      }
                      title={formik.values["SecondarySubscriberDOB"]}
                      // placeholder={ele.placeholder}
                      value={formik.values.SecondarySubscriberDOB}
                      onChange={(date, dateString) =>
                        formik.setFieldValue("SecondarySubscriberDOB", date)
                      }
                      // disabled={editMode ? !ele.isEditable : ele.isEditable}
                      disabled={!isEditable}
                    />
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6}>
                    <label className="form-label">Type of Plan</label>
                    <Input
                      name="SecondaryTypeOfPlan"
                      value={formik.values.SecondaryTypeOfPlan}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "SecondaryTypeOfPlan",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["SecondaryTypeOfPlan"] &&
                      formik.touched["SecondaryTypeOfPlan"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["SecondaryTypeOfPlan"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Insurance Phone Number</label>
                    <Input
                      name="SecondaryInsurancePhoneNumber"
                      value={formik.values.SecondaryInsurancePhoneNumber}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "SecondaryInsurancePhoneNumber",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["SecondaryInsurancePhoneNumber"] &&
                      formik.touched["SecondaryInsurancePhoneNumber"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["SecondaryInsurancePhoneNumber"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Provider in Network</label>
                    <Input
                      name="SecondaryProviderInNetwork"
                      value={formik.values.SecondaryProviderInNetwork}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "SecondaryProviderInNetwork",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["SecondaryProviderInNetwork"] &&
                      formik.touched["SecondaryProviderInNetwork"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["SecondaryProviderInNetwork"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={24} style={{ width: "100%" }}>
                    <label className="form-label">
                      Secondary Insurance Card
                    </label>
                    <p className="input-subtitle">
                      Choose from accounts under your scope
                    </p>
                    <Upload.Dragger
                      {...uploadProps}
                      customRequest={({ file, onSuccess }) =>
                        handleFile(
                          { file, onSuccess },
                          "SecondaryInsuranceCard"
                        )
                      }
                      onPreview={() => downloadFile("SecondaryInsuranceCard")}
                      fileList={secondaryInsuranceCardFileList}
                      onRemove={() => {
                        setSecondaryInsuranceCard(null);
                        setSecondaryInsuranceCardFileList([]);
                        setSecondaryInsuranceCardFilename(null);
                      }}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Drag or click to upload file
                      </p>
                      <p className="ant-upload-hint">
                        Accepted format: PDF (Max file size limit: 4MB)
                      </p>
                    </Upload.Dragger>
                  </Col>
                </Row>
                <div
                  style={{
                    background: "#e3e3e3",
                    borderRadius: "5px",
                    padding: "0px 8px",
                    margin: "110px 0px 20px 0px",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "36px",
                    }}
                  >
                    More Details
                  </p>
                </div>
                <Row gutter={16}>
                  <Col span={6}>
                    <label className="form-label">Wound Type</label>
                    <p className="input-subtitle">
                      Separate wounds with commas
                    </p>
                    <Input
                      name="WoundType"
                      value={formik.values.WoundType}
                      onChange={(event) =>
                        formik.setFieldValue("WoundType", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["WoundType"] &&
                      formik.touched["WoundType"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["WoundType"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Wound Size</label>
                    <p className="input-subtitle">Separate sizes with commas</p>
                    <Input
                      name="WoundSize"
                      value={formik.values.WoundSize}
                      onChange={(event) =>
                        formik.setFieldValue("WoundSize", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["WoundSize"] &&
                      formik.touched["WoundSize"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["WoundSize"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">Application CPT</label>
                    <p className="input-subtitle">Separate CPTs with commas</p>
                    <Input
                      name="ApplicationCPT"
                      value={formik.values.ApplicationCPT}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "ApplicationCPT",
                          event.target.value
                        )
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["ApplicationCPT"] &&
                      formik.touched["ApplicationCPT"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["ApplicationCPT"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6}>
                    <label className="form-label">ICD-10 Diagnosis Code</label>
                    <p className="input-subtitle">Separate codes with commas</p>
                    <Input
                      name="ICD10"
                      value={formik.values.ICD10}
                      onChange={(event) =>
                        formik.setFieldValue("ICD10", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    {formik.errors["ICD10"] && formik.touched["ICD10"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["ICD10"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={24} style={{ width: "100%" }}>
                    <label className="form-label">
                      Patient's Clinical Record
                    </label>
                    <p className="input-subtitle">
                      Upload Patient's Clinical Record
                    </p>
                    <Upload.Dragger
                      {...uploadProps}
                      customRequest={({ file, onSuccess }) =>
                        handleFile({ file, onSuccess }, "PatientClinicalRecord")
                      }
                      onPreview={() => downloadFile("PatientClinicalRecord")}
                      fileList={patientClinicalRecordFileList}
                      onRemove={() => {
                        setPatientClinicalRecord(null);
                        setPatientClinicalRecordFileList([]);
                        setPatientClinicalRecordFilename(null);
                      }}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Drag or click to upload file
                      </p>
                      <p className="ant-upload-hint">
                        Accepted format: PDF (Max file size limit: 4MB)
                      </p>
                    </Upload.Dragger>
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "100px" }}>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">
                      Is patient currently residing in SNF?{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    {/* <Input
                      name="PatientResidingInSNF"
                      value={formik.values.PatientResidingInSNF}
                      onChange={(event) => formik.setFieldValue('PatientResidingInSNF', event.target.value)}
                      disabled={!isEditable}
                    /> */}
                    <Select
                      onBlur={() =>
                        formik.setFieldTouched("PatientResidingInSNF")
                      }
                      title={formik.values["PatientResidingInSNF"]}
                      value={{
                        label: formik.values["PatientResidingInSNF"],
                        value: formik.values["PatientResidingInSNF"],
                      }}
                      style={{ width: "100%" }}
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      onChange={(selectedOption) => {
                        formik.setFieldValue(
                          "PatientResidingInSNF",
                          selectedOption.value
                        );
                      }}
                    />
                    {formik.errors["PatientResidingInSNF"] &&
                      formik.touched["PatientResidingInSNF"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["PatientResidingInSNF"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">
                      Is the patient under a surgical global period?{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    {/* <Input
                      name="SurgicalGlobalPeriod"
                      value={formik.values.SurgicalGlobalPeriod}
                      onChange={(event) => formik.setFieldValue('SurgicalGlobalPeriod', event.target.value)}
                      disabled={!isEditable}
                    /> */}
                    <Select
                      onBlur={() =>
                        formik.setFieldTouched("SurgicalGlobalPeriod")
                      }
                      title={formik.values["SurgicalGlobalPeriod"]}
                      value={{
                        label: formik.values["SurgicalGlobalPeriod"],
                        value: formik.values["SurgicalGlobalPeriod"],
                      }}
                      style={{ width: "100%" }}
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      onChange={(selectedOption) => {
                        formik.setFieldValue(
                          "SurgicalGlobalPeriod",
                          selectedOption.value
                        );
                      }}
                    />

                    {formik.errors["SurgicalGlobalPeriod"] &&
                      formik.touched["SurgicalGlobalPeriod"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["SurgicalGlobalPeriod"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">
                      Is Patient currently in Hospice?{" "}
                    </label>
                    {/* <Input
                      name="SurgicalGlobalPeriod"
                      value={formik.values.SurgicalGlobalPeriod}
                      onChange={(event) => formik.setFieldValue('SurgicalGlobalPeriod', event.target.value)}
                      disabled={!isEditable}
                    /> */}
                    <Select
                      onBlur={() => formik.setFieldTouched("PatientInHospice")}
                      title={formik.values["PatientInHospice"]}
                      value={{
                        label: formik.values["PatientInHospice"],
                        value: formik.values["PatientInHospice"],
                      }}
                      style={{ width: "100%" }}
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      onChange={(selectedOption) => {
                        formik.setFieldValue(
                          "PatientInHospice",
                          selectedOption.value
                        );
                      }}
                    />

                    {/* {formik.errors["PatientInHospice"] && formik.touched["PatientInHospice"] ? (
                      <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["PatientInHospice"]}</div>
                    ) : null} */}
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">HCPCS Codes</label>
                    <Input
                      name="CPTCode"
                      value={formik.values.CPTCode}
                      onChange={(event) =>
                        formik.setFieldValue("CPTCode", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    <p className="input-subtitle">
                      Separate multiple HCPCS Codes with commas
                    </p>
                    {formik.errors["CPTCode"] && formik.touched["CPTCode"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["CPTCode"]}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={6} style={{ width: "100%" }}>
                    <label className="form-label">Date Of Procedure</label>
                    <DatePicker
                      format="MM-DD-YYYY"
                      onBlur={() => formik.setFieldTouched("DateOfProcedure")}
                      title={formik.values["DateOfProcedure"]}
                      // placeholder={ele.placeholder}
                      value={formik.values.DateOfProcedure}
                      onChange={(date, dateString) =>
                        formik.setFieldValue("DateOfProcedure", date)
                      }
                      // disabled={editMode ? !ele.isEditable : ele.isEditable}
                      disabled={!isEditable}
                    />
                  </Col>
                </Row>
                <div
                  style={{
                    background: "#e3e3e3",
                    borderRadius: "5px",
                    padding: "0px 8px",
                    marginBottom: "10px",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      lineHeight: "36px",
                    }}
                  >
                    Signature <span style={{ color: "red" }}>*</span>
                  </p>
                </div>
                <Row gutter={16}>
                  <Col span={24}>
                    <label className="form-label">
                      By signing below, I certify that I have received the
                      necessary patient authorization to release the medical
                      and/or other patient information referenced on the form
                      relating to the above-referenced patient. This information
                      is for verifying insurance coverage, seeking
                      reimbursement, and the sole purpose of claim support.
                    </label>
                    <p className="input-subtitle">
                      Please print your Full Name. This will serve as your
                      e-signature.
                    </p>
                    <Input
                      name="Signature"
                      value={formik.values.Signature}
                      onChange={(event) =>
                        formik.setFieldValue("Signature", event.target.value)
                      }
                      disabled={!isEditable}
                    />
                    <p>
                      This verification of benefits is not a guarantee of
                      payment by the payor, but is deemed as current coverage
                      information as relayed by the payor. This verification
                      cannot take the place of written policy guidance from the
                      payor.
                    </p>
                    {formik.errors["Signature"] &&
                      formik.touched["Signature"] ? (
                      <div
                        style={{
                          color: "red",
                          paddingTop: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {formik.errors["Signature"]}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                {params?.id === null ||
                  (params?.id === undefined && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "20px",
                      }}
                    >
                      <Button
                        onClick={formik.handleSubmit}
                        type="primary"
                        icon={<CheckOutlined />}
                        style={{
                          background: "#27a907",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  ))}
                {showAddContactModal && selectedAccount && (
                  <div>
                    <Modal
                      title="New Contact"
                      open={showAddContactModal}
                      onOk={handleOkAddContact}
                      onCancel={handleCancelAddContact}
                      centered={true}
                      footer={false}
                    >
                      <AddContactForm accountData={selectedAccount} />
                    </Modal>
                  </div>
                )}
                {showBAAModal && selectedAccount && (
                  <div>
                    <Modal
                      title="BAA Not Available"
                      open={showBAAModal}
                      onCancel={() => setShowBAAModal(false)}
                      centered={true}
                      footer={false}
                      maskClosable={false}
                    >
                      <p>
                        Our records indicate that we do not have a BAA form for
                        your account. In order to submit an IVR request, you
                        need to fill and send the BAA form to
                        support@advancedsolution.health. Please download the
                        form using the button below.
                      </p>
                      <Button
                        type="primary"
                        onClick={() => downloadBAAForm()}
                        style={{
                          background: "#27a907",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Download
                      </Button>
                    </Modal>
                  </div>
                )}
              </form>
            )}
          </Formik>
        )}
      </div>
    </>
  );
};

export default IVRFormAdd;
